import { AddressObservable } from './address.observable'
import { createPersistObservable } from '~/observables/utils/create-persist-observable'

export const addressObservable = createPersistObservable(
  AddressObservable,
  'address_observable',
)
